import { useQuery } from "@tanstack/react-query";
import { fetchCompanyPaymentsStatus } from "../actions/payments";

export function useCompanyPaymentsStatusQuery(companyId?: string | number) {
  return useQuery({
    queryKey: ["company-payments-status", companyId],
    enabled: companyId !== undefined && companyId !== null && companyId !== "",
    staleTime: 60_000,
    queryFn: ({ queryKey }) => {
      const [, id] = queryKey as ["company-payments-status", string | number];
      return fetchCompanyPaymentsStatus(id);
    },
  });
}